export interface HeroData {
  name: string;
  title: string;
  subtitle: string;
  description: string;
  location: string;
  email: string;
  profileImage: string;
  quote: string;
  socialLinks: {
    email: string;
    website: string;
    youtube: string;
    github?: string;
    linkedin?: string;
    twitter?: string;
  };
  downloadCvUrl: string;
}

export const heroData: HeroData = {
  name: "Tran Duc Giang",
  title: "Tech Lead / Senior Software Developer",
  subtitle: "Tech Lead / Software Developer Lead",
  description:
    "Tech Lead / Senior Software Developer with 5+ years of experience in React Native, Node.js, and .NET development. Proven expertise in building high-performance systems, leading Dev teams, and delivering scalable solutions for both startups and enterprises.",
  location: "Van Quan, Ha Dong, Ha Noi",
  email: "tranducgiangact@gmail.com",
  profileImage: "/assets/images/profile-avatar.jpg",
  quote: "It only has to work once",
  socialLinks: {
    email: "tranducgiangact@gmail.com",
    website: "https://www.ducgiangtran.dev/",
    youtube: "https://www.youtube.com/@giangtranduc98",
    github: "https://github.com/ducgiangtrankma",
    linkedin: "https://www.linkedin.com/in/giang-tran-417338223/",
  },
  downloadCvUrl: "/assets/documents/TranDucGiang_SeniorSoftwareEngineer.pdf",
};
